import { render, staticRenderFns } from "./SrsForm.vue?vue&type=template&id=562df36a&scoped=true&"
import script from "./SrsForm.vue?vue&type=script&lang=ts&"
export * from "./SrsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SrsForm.vue?vue&type=style&index=0&id=562df36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562df36a",
  null
  
)

export default component.exports